export default __webpack_public_path__ + "static/media/StatusArrivedFill.2848e839.svg";